import type {
  AwaitingEvidenceItem,
  AwaitingEvidenceTarget,
} from "@/features/cle-compliance/models/awaitingEvidence";
import type { ReportingLessonsStatus } from "@/features/cle-compliance/models/reportingLessonsStatus";
import { get } from "./util";

const METADATA_QUERY = "documents/metadata/lessons-available-for-period";
const PENDING_EVIDENCE_QUERY = "documents/metadata/pending-evidence";

const toDateOnlyQueryValue = (value: string): string => value.slice(0, 10);

export const fetchReportingLessonsStatus = (
  periodStart: string,
  periodEnd: string,
): Promise<ReportingLessonsStatus> =>
  get<ReportingLessonsStatus>({
    query: `${METADATA_QUERY}?periodStart=${encodeURIComponent(
      toDateOnlyQueryValue(periodStart),
    )}&periodEnd=${encodeURIComponent(toDateOnlyQueryValue(periodEnd))}`,
  });

export const fetchAwaitingEvidence = ({
  kind,
  id,
}: AwaitingEvidenceTarget): Promise<AwaitingEvidenceItem[]> =>
  get<AwaitingEvidenceItem[]>({
    query: `${PENDING_EVIDENCE_QUERY}/${kind}/${encodeURIComponent(id)}`,
  });
